import { render, staticRenderFns } from "./addressComponent.vue?vue&type=template&id=5e6361dd&scoped=true&"
import script from "./addressComponent.vue?vue&type=script&lang=js&"
export * from "./addressComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6361dd",
  null
  
)

export default component.exports